/* istanbul ignore file */
/* istanbul ignore file */
import { LinkField, useFieldHelper } from 'framework/ui/field';
import React from 'react';
import useRedmineUrl from 'infrastructure/integrations/redmine/useRedmineUrl';

// @ts-ignore
const RedmineIssueField = ({ source, ...props }) => {
  const { getValue: getId } = useFieldHelper<number>({ source });
  const { getIssueUrl } = useRedmineUrl();

  const id = getId();
  const value = id && getIssueUrl(id);

  return <LinkField {...props} linkText={id} value={value as string} isInternal={false} />;
};

export default RedmineIssueField;
